import React, { Component } from "react";

export const withGate = (WrappedCmp, key) =>
  class extends Component {
    render() {
      if (this.props.hasOwnProperty(key)) return <WrappedCmp {...this.props} />;
      return <div />;
    }
  };



// WEBPACK FOOTER //
// ./src/components/Gate/index.js